import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import ICU from "i18next-icu";

i18n
  .use(ICU)
  .use(HttpApi)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    load: "all",
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      allowMultiLoading: true,
      loadPath: "/translations/{{lng}}.json",
      requestOptions: {
        cache: "no-store",
      },
    },
  });

export default i18n;
